function parseQuantity(input) {
  if (!input) return 1;

  const min = parseInt(input.getAttribute("min") || "1", 10);
  const step = parseInt(input.getAttribute("step") || "1", 10);
  let qty = parseInt(input.value, 10);

  if (isNaN(qty) || qty < min) qty = min;

  if (step > 1 && qty % step !== 0) {
    qty = Math.floor(qty / step) * step || min;
  }

  return qty;
}

function getCartApiErrorMessage(data) {
  const msg = data?.message;
  const desc = data?.description;

  if (msg && (!desc || desc === "Cart Error")) return msg;
  if (desc && desc !== "Cart Error") return desc;
  return msg || desc || window.quickOrderStrings?.error || "Error";
}

function setButtonLoading(btn, isLoading) {
  if (!btn) return;

  const textEl = btn.querySelector("[data-quick-order-add-text]");
  const spinner = btn.querySelector(".spinner-loading-btn");

  if (isLoading) {
    btn.classList.add("loading");
    btn.setAttribute("aria-disabled", "true");
    textEl?.classList.add("hidden");
    spinner?.classList.remove("hidden");
  } else {
    btn.classList.remove("loading");
    if (!btn.disabled) btn.removeAttribute("aria-disabled");
    textEl?.classList.remove("hidden");
    spinner?.classList.add("hidden");
  }
}

function showAddedMessage(messageEl, qty) {
  if (!messageEl) return;
  const tpl =
    qty === 1
      ? window.quickOrderStrings?.itemAdded
      : window.quickOrderStrings?.itemsAdded;
  messageEl.textContent = (tpl || "").replace("[quantity]", String(qty));
}

function getVariantQuantityFromCart(cart, variantId) {
  return (cart.items || [])
    .filter((item) => String(item.variant_id) === String(variantId))
    .reduce((sum, item) => sum + (item.quantity || 0), 0);
}

async function fetchCart() {
  return fetch(`${routes.cart_url}.js`).then((r) => r.json());
}

function updateHeaderCartCount(itemCount) {
  document.querySelectorAll("[data-item-count]").forEach((el) => {
    if (itemCount == 0) {
      el.classList.add("hidden");
    } else {
      el.classList.remove("hidden");
      el.textContent = itemCount < 100 ? String(itemCount) : "99+";
    }
  });
}

function syncQuantityInput(qtyInput, cartQty, addedQty) {
  if (!qtyInput) return;
  qtyInput.setAttribute("data-cart-quantity", String(cartQty));
  if (addedQty > 0) qtyInput.value = String(addedQty);
}

async function refreshCartDrawer(response, { open = true } = {}) {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  let parsedState = response;
  if (!parsedState?.sections && cartDrawer.getSectionsToRender) {
    const ids = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id)
      .join(",");
    const sections = await fetch(`${routes.cart_url}?sections=${ids}`).then(
      (r) => r.json(),
    );
    parsedState = { sections };
  }

  if (!parsedState?.sections) return;

  cartDrawer.renderContents(parsedState);

  if (open) {
    cartDrawer.classList.add("open");
    document.querySelector("body")?.classList.add("no-scroll");
  }
}

async function addToCart(variantId, quantity) {
  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", quantity);

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer?.getSectionsToRender) {
    formData.append(
      "sections",
      cartDrawer.getSectionsToRender().map((section) => section.id),
    );
    formData.append("sections_url", window.location.pathname);
  }

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];
  config.body = formData;

  const response = await fetch(routes.cart_add_url, config);
  return response.json();
}

async function syncCartAfterAdd(
  data,
  { qtyInput, variantId, cartQtyBefore, openDrawer },
) {
  const cartAfter = await fetchCart();
  const cartQtyAfter = getVariantQuantityFromCart(cartAfter, variantId);
  const addedQty = cartQtyAfter - cartQtyBefore;

  if (addedQty > 0) {
    syncQuantityInput(qtyInput, cartQtyAfter, addedQty);
    updateHeaderCartCount(cartAfter.item_count);
    await refreshCartDrawer(data, { open: openDrawer });

    publish?.(PUB_SUB_EVENTS.cartUpdate, {
      source: "quick-order",
      productVariantId: parseInt(variantId, 10),
      cartState: cartAfter,
    });
  }

  return addedQty;
}

document.addEventListener("click", async (event) => {
  const btn = event.target.closest("[data-quick-order-add]");
  if (!btn) return;

  event.preventDefault();
  if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  const variantEl = btn.closest(".quick-order__variant");
  const qtyInput = variantEl?.querySelector("[data-quick-order-qty-input]");
  const requestedQty = parseQuantity(qtyInput);

  const messageEl = variantEl?.querySelector(".quick-order__variant-message");
  if (messageEl) messageEl.textContent = "";

  setButtonLoading(btn, true);

  try {
    const cartBefore = await fetchCart();
    const cartQtyBefore = getVariantQuantityFromCart(cartBefore, variantId);
    const data = await addToCart(variantId, requestedQty);

    if (data?.status) {
      if (messageEl) messageEl.textContent = getCartApiErrorMessage(data);
      await syncCartAfterAdd(data, {
        qtyInput,
        variantId,
        cartQtyBefore,
        openDrawer: false,
      });
      return;
    }

    if (data?.errors) {
      const msg =
        typeof data.errors === "string"
          ? data.errors
          : Object.values(data.errors).join(", ");
      if (messageEl) messageEl.textContent = msg;
      await syncCartAfterAdd(data, {
        qtyInput,
        variantId,
        cartQtyBefore,
        openDrawer: false,
      });
      return;
    }

    const addedQty = await syncCartAfterAdd(data, {
      qtyInput,
      variantId,
      cartQtyBefore,
      openDrawer: true,
    });
    showAddedMessage(messageEl, addedQty > 0 ? addedQty : requestedQty);
  } catch (e) {
    console.error(e);
    if (messageEl) {
      messageEl.textContent = window.quickOrderStrings?.error || "Error";
    }
  } finally {
    setButtonLoading(btn, false);
  }
});
